import type React from 'react';
import { useAutoRefillStore } from '../../../stores/useAutoRefillStore';

interface AutoRefillHeaderProps {
  config: {
    customerServicePhone: string;
    customerServiceEmail: string;
  };
}

export function AutoRefillHeader({ config: _config }: AutoRefillHeaderProps) {
  const { refillUsers, selectedLinkToken, setSelectedUser, fetchAutoRefills } =
    useAutoRefillStore();

  function handleUserChange(e: React.ChangeEvent<HTMLSelectElement>) {
    const token = e.target.value;
    setSelectedUser(token);
    void fetchAutoRefills(token);
  }

  return (
    <div className="col-md-3 refill-sidebar-listgroup">
      <div className="panel">
        <div className="panel-body auto-refill-dropdown">
          <ul className="list-group">
            <li className="list-group-item">
              <strong>Manage Auto-Refills For:</strong>
              <select
                className="report-user custom form-control"
                value={selectedLinkToken ?? ''}
                onChange={handleUserChange}
              >
                {refillUsers.map(u => (
                  <option key={u.LinkToken} value={u.LinkToken}>
                    {u.Name}
                  </option>
                ))}
              </select>
            </li>
          </ul>
        </div>
      </div>


    </div>
  );
}
